
export class OverlapInfo {

    constructor(doorPositions: number[], openingWidth: number, overlapWidth: number) {
        this.doorPositions = doorPositions.slice(); //copy array
        this.numOverlaps = OverlapInfo.getNumOverlaps(doorPositions);
        const totalDoorWidth = openingWidth + (this.numOverlaps * overlapWidth);
        const numDoors = doorPositions.length;
        this.doorWidth = (numDoors > 0)
            ? totalDoorWidth / numDoors
            : 0;

    }
    readonly doorPositions: number[];
    readonly numOverlaps: number;
    readonly doorWidth: number;

    private static getNumOverlaps(railPositions: number[]): number {
        let result = 0;
        let prevPos = railPositions[0];
        for (let pos of railPositions) {
            if (pos !== prevPos)
                result++;
            prevPos = pos;
        }
        return result;
    }
}
